import * as consts from './MainConsts';
import { getBackgroundImageReq } from '../helpers/requestUtils';

export const getBackgroundPhoto = () => {
  return (dispatch, getState) => {
    const tourId = getState().app.tourId;

    dispatch({ type: consts.GET_BACKGROUND_PHOTO_PENDING });
    getBackgroundImageReq(tourId).then(
      data => {
        if (data.Error.length) {
          dispatch({ type: consts.GET_BACKGROUND_PHOTO_REJECTED });
        } else {
          dispatch({
            type: consts.GET_BACKGROUND_PHOTO_FULFILLED,
            payload: data.data
          });
        }
      },
      () => {
        dispatch({ type: consts.GET_BACKGROUND_PHOTO_REJECTED });
      }
    );
  };
};

export const setTimeoutStartComponent = (dashboard, hero) => {
  return (dispatch, getState) => {
    if (!hero) {
      dispatch({
        type: consts.CHANGE_COMPONENT,
        payload: dashboard ? false : !getState().main.startComponentRender
      });
    } else {
      dispatch({
        type: consts.CHANGE_COMPONENT,
        payload: true
      });
    }
  };
};
